import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { handleDetailInfoModalOpened, handleSetActiveImageIndex } from "@/src/store/listingDetail";

import PhotoIcon from "assets/svg/thumb_list_photo.svg";
import VideoIcon from "assets/svg/thumb_list_video.svg";
import VirtualTourIcon from "assets/svg/thumb_list_3d.svg";

import { createImageUrl } from "@/src/helpers/create-image-url";
import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";
import { runIdle } from "@/src/utils/idle-utils";

import BannerActionButtons from "components/listing-detail/banner-action-buttons";
import ListItem from "./list-item";
import { LazyImage } from "components/common/lazy-image/LazyImage";

import styles from "./styles.module.css";

const PhotoThumbnails = ({ listingId, images, videoUrl = null, virtualTourUrl = null }) => {
  const dispatch = useDispatch();

  const handleOpenDetailInfoModal = (activeTabName, activeImageIndex) => {
    setTimeout(() => {
      dispatch(handleDetailInfoModalOpened(activeTabName));
      if (activeTabName === "picture") setActiveImageIndex(activeImageIndex);
    }, 0);

    runIdle(() => {
      Ga4WithEventParameters({
        eventName: "click_button",
        eventParameters: { label: "galeri||full-screen" },
      });
    }, 1000);
  };

  const setActiveImageIndex = (activeImageIndex) => dispatch(handleSetActiveImageIndex(activeImageIndex));

  const getImageUrlForFullSizedPath = (imageUrl, width, height) =>
    createImageUrl(imageUrl, {
      width,
      height,
    });

  return (
    <div className={styles.wrapper}>
      <BannerActionButtons listingId={listingId} />
      <div className={styles.coverWrap}>
        <LazyImage
          src={getImageUrlForFullSizedPath(images[0], 736, 415)}
          onClick={() => handleOpenDetailInfoModal("picture", 0)}
          width="736px"
          visibleByDefault
          fetchPriority="high"
        />
        <div className={styles.propertiesList}>
          <ul>
            {images.length && (
              <ListItem
                icon={<PhotoIcon />}
                label={`${images.length} Fotoğraf`}
                handleClick={() => handleOpenDetailInfoModal("picture", 0)}
              />
            )}
            {videoUrl && (
              <ListItem icon={<VideoIcon />} label="Video" handleClick={() => handleOpenDetailInfoModal("video")} />
            )}
            {virtualTourUrl && (
              <ListItem
                icon={<VirtualTourIcon />}
                label="3D Tur"
                handleClick={() => handleOpenDetailInfoModal("three-d")}
              />
            )}
          </ul>
        </div>
      </div>
      <div className={styles.othersWrap}>
        <LazyImage
          src={getImageUrlForFullSizedPath(images.length >= 2 ? images[1] : null, 364, 202)}
          onClick={images.length >= 2 ? () => handleOpenDetailInfoModal("picture", 1) : null}
          style={{ pointerEvents: images.length >= 2 ? "auto" : "none" }}
          width="364px"
          visibleByDefault
          fetchPriority="high"
        />
        <LazyImage
          src={getImageUrlForFullSizedPath(images.length >= 3 ? images[2] : null, 364, 202)}
          onClick={images.length >= 3 ? () => handleOpenDetailInfoModal("picture", 2) : null}
          style={{ pointerEvents: images.length >= 3 ? "auto" : "none" }}
          width="364px"
          visibleByDefault
          fetchPriority="high"
        />
      </div>
    </div>
  );
};

PhotoThumbnails.propTypes = {
  listingId: PropTypes.number,
  images: PropTypes.array,
  videoUrl: PropTypes.string,
  virtualTourUrl: PropTypes.string,
};

export default PhotoThumbnails;
